import React from "react";
import "./ProductHero.css";
import image from "../assetsproduct/mainimage.png";

export default function ProductHero() {
  return (
    <div id="product-hero" className="productmainclass">
      <h2 className="heading">Best Product Development Services in India</h2>
      <p className="subheading">
       Get product development services that help startups launch faster—150+ products delivered, 3x quicker time-to-market, 35% performance boost, and reliable platforms designed to grow as your user base expands.
      </p>
      <div className="image">
        <img src={image} alt="error" />
      </div>
    </div>
  );
}
